export default {
// NavSidebarHOC
	inboxTitle: "Meeting Inbox",
	teamsGroupTitle: "My Teams",
	oneOnOnesGroupTitle: "My 1:1s",
	meetingsGroupTitle: "Meetings",
	goalsGroupTitle: "Goals",
	commitmentsGroupTitle: "My Action Items",
	profileGroupTitle: "My Profile",
	demoGroupTitle: "Schedule a Demo",
	settingsGroupTitle: "Settings & Billing",
	signOutGroupTitle: "Sign out",
	subscribeGroupTitle: "Trial mode. Buy now.",
};
